"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailSwitch = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../../../../../hooks");
var _Switch = require("./Switch");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EmailSwitch = function EmailSwitch() {
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  var _useEmail2faSwitch = (0, _hooks.useEmail2faSwitch)(),
    checked = _useEmail2faSwitch.checked,
    disabled = _useEmail2faSwitch.disabled,
    isLastChecked = _useEmail2faSwitch.isLastChecked,
    enableForbidden = _useEmail2faSwitch.enableForbidden,
    onChange = _useEmail2faSwitch.onChange;
  return /*#__PURE__*/_react.default.createElement(_Switch.Switch, {
    title: t('emailAuth.title'),
    subtitle: t('emailAuth.subtitle'),
    isLastChecked: isLastChecked,
    inputProps: {
      checked: checked,
      disabled: disabled,
      onChange: onChange
    },
    tooltipText: enableForbidden ? t('email2faEnableForbidden') : undefined
  });
};
exports.EmailSwitch = EmailSwitch;